import React, { useState, useEffect } from "react";
import { HashLink } from "react-router-hash-link";

const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [hidden, setHidden] = useState(false);
  const [lastScrollY, setLastScrollY] = useState(0);

  // ✅ Handle scroll hiding
  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      if (currentScrollY > lastScrollY && currentScrollY > 50) {
        setHidden(true);
      } else {
        setHidden(false);
      }
      setLastScrollY(currentScrollY);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [lastScrollY]);

  // ✅ Lock/unlock scroll when sidebar is open
  useEffect(() => {
    if (menuOpen) {
      document.body.style.overflow = "hidden";
      document.body.style.paddingRight = "15px"; // prevent layout shift
    } else {
      document.body.style.overflow = "auto";
      document.body.style.paddingRight = "0px";
    }
  }, [menuOpen]);

  return (
    <>
      {/* ✅ Sticky Header */}
      <header
        className={`fixed top-0 left-0 right-0 z-50 transition-transform duration-500 ${
          hidden ? "-translate-y-full" : "translate-y-0"
        }`}
      >
        <div
          className="
          md:w-[100%] md:h-[80px] bg-[#FFFFFF] shadow-lg mx-auto my-4 rounded-full pt-2 border border-1 border-gray-200
          sm:auto sm:h-[80px]"
        >
          <div className="max-w-7xl mx-auto px-6 h-full flex items-center justify-between">
            {/* ✅ Logo */}
            <div className=" relative flex items-center justify-center space-x-2 font-montserrat">
              <img src="MM Logo.jpg" alt="MM Coding Lingo" className="pb-2 w-[170px] h-1 lg:w-60 h-12 md:p-0" />
              
            </div>

            {/* ✅ Desktop Navigation */}
            <nav className="hidden md:flex md:space-x-3 lg:space-x-6 font-roboto">
              <HashLink smooth to="/#home" className="text-red-700 font-medium">
                Home
              </HashLink>
              <HashLink smooth to="/#about" className="text-gray-600 hover:text-red-700">
                About
              </HashLink>
              <HashLink smooth to="/#Services" className="text-gray-600 hover:text-red-700">
                Services
              </HashLink>
              <HashLink smooth to="/#Work" className="text-gray-600 hover:text-red-700">
                Our Work
              </HashLink>
              <HashLink smooth to="/#client" className="text-gray-600 hover:text-red-700">
                Client Testimonial
              </HashLink>
              <HashLink smooth to="/#FAQs" className="text-gray-600 hover:text-red-700">
                FAQs
              </HashLink>
            </nav>

            {/* ✅ Desktop Contact Button */}
            <HashLink
              to="/ContactUs"
              className="hidden md:inline-block bg-[#B20925] text-white px-4 py-2 rounded-full hover:bg-red-800 transition font-roboto h-10 w-28"
            >
              <div className="flex justify-center items-center">Contact Us</div>
            </HashLink>

            {/* ✅ Hamburger Button */}
            <button
              onClick={() => setMenuOpen(!menuOpen)}
              className="md:hidden flex flex-col space-y-1.5 focus:outline-none z-50"
            >
              <span className="block w-6 h-0.5 bg-[#B20925]"></span>
              <span className="block w-6 h-0.5 bg-[#B20925]"></span>
              <span className="block w-6 h-0.5 bg-[#B20925]"></span>
            </button>
          </div>
        </div>
      </header>

      {/* ✅ Space below header so content doesn’t overlap */}
      <div className="h-[90px]"></div>

      {/* ✅ Sidebar Overlay */}
      <div
        className={`fixed inset-0 bg-white/10 backdrop-blur-sm z-40 transition-all duration-500 ease-in-out ${
          menuOpen ? "opacity-100 visible" : "opacity-0 invisible"
        }`}
        onClick={() => setMenuOpen(false)}
      ></div>

      {/* ✅ Sidebar Menu */}
      <div
        className={`fixed top-0 right-0 h-full w-64 bg-white shadow-2xl z-50 transform transition-transform duration-300 ease-in-out font-roboto ${
          menuOpen ? "translate-x-0" : "translate-x-full"
        }`}
      >

          {/* Close Button */}
          <button
            onClick={() => setMenuOpen(false)}
            className="absolute top-4 left-4 text-gray-600 hover:text-red-600 transition"
            aria-label="Close menu"
          >
           ✕
          </button>

        <div className="p-6 space-y-6 mt-10">
          <HashLink smooth to="/#home" onClick={() => setMenuOpen(false)} className="block text-red-700 font-medium">
            Home
          </HashLink>
          <HashLink smooth to="/#about" onClick={() => setMenuOpen(false)} className="block text-gray-600 hover:text-red-700">
            About
          </HashLink>
          <HashLink smooth to="/#Services" onClick={() => setMenuOpen(false)} className="block text-gray-600 hover:text-red-700">
            Services
          </HashLink>
          <HashLink smooth to="/#Work" onClick={() => setMenuOpen(false)} className="block text-gray-600 hover:text-red-700">
            Our Work
          </HashLink>
          <HashLink smooth to="/#client" onClick={() => setMenuOpen(false)} className="block text-gray-600 hover:text-red-700">
            Client Testimonial
          </HashLink>
          <HashLink smooth to="/#FAQs" onClick={() => setMenuOpen(false)} className="block text-gray-600 hover:text-red-700">
            FAQs
          </HashLink>
          <HashLink
            to="/ContactUs"
            onClick={() => setMenuOpen(false)}
            className="block bg-[#B20925] text-white px-4 py-2 rounded-full hover:bg-red-800 transition text-center font-roboto"
          >
            Contact Us
          </HashLink>
        </div>
      </div>
    </>
  );
};

export default Header;
